import React from "react";
import BulkPaymentHero from "./bulk-payment/BulkPaymentHero";
import WorkSmarter from "./bulk-payment/WorkSmarter";
import JoinNetwork from "./bulk-payment/JoinNetwork";
import WorkPayment from "./bulk-payment/WorkPayment";
import svg98 from "../../../assets/svg/svg98.svg";  
import svg105 from "../../../assets/svg/svg105.svg";
import svg108 from "../../../assets/svg/svg108.svg";
import svg109 from "../../../assets/svg/svg109.svg";
import svg111 from "../../../assets/svg/svg111.svg";
import svg112 from "../../../assets/svg/svg112.svg";
import img5 from "../../../assets/img/img5.png";
import svg110 from "../../../assets/svg/svg110.svg";
import svg113 from "../../../assets/svg/svg113.svg";
import svg114 from "../../../assets/svg/svg114.svg";
import svg115 from "../../../assets/svg/svg115.svg";
import svg116 from "../../../assets/svg/svg116.svg";
import svg117 from "../../../assets/svg/svg117.svg";

const itemsHero = [
  {
    title: "Instant Settlements",
    svg: svg98,
    desc: "Disburse to banks or mobile wallets instantly. No waiting, no errors.",
  },
  {
    title: "Vendor Management",
    svg: svg110,
    desc: "Keep supplier records, track history, and monitor pending invoices effortlessly.",
  },
  {
    title: "Controlled Approvals",
    svg: svg113,
    desc: "Set roles and limits to ensure every payment is authorized and compliant.",
  },
];
const titleHero = "Pay Bills and Settle Suppliers Seamlessly";
const subtitleHero =
  "Handle all your bills and vendor payments from one secure dashboard. Fast, transparent, and on time.";

const itemsSmarter = [
  {
    title: "Eliminate Late Payments",
    svg: svg114,
    desc: "Automate repetitive payout processes and eliminate human mistakes with smart validation tools.",
  },
  {
    title: "Automate Workflows",
    svg: svg105,
    desc: "Reduce manual effort with automated approvals and reconciliation.",
  },
  {
    title: "Vendor Relationships",
    svg: svg115,
    desc: "Handle payments in KES, USD, or other supported currencies seamlessly from one dashboard.",
  },
  {
    title: "Transparency",
    svg: svg116,
    desc: "Every transaction is logged, receipted, and easy to audit.",
  },
    {
    title: "Lower Administrative Costs",
    svg: svg117,
    desc: "Save time and resources by managing all bills from one smart platform.",
  },
];

const titleSmarter = "Smart Tools for Effortless Bill Management";
const subtitleSmarter =
  "Handle bills and supplier payments with features that keep every transaction fast, organized, and fully transparent.";

const itemsWorkPayment = [
  {
    svg: svg108,
    title: "Add Your Bills",
    desc: "Upload invoices manually or in bulk for multiple suppliers.",
  },
  {
    svg: svg109,
    title: "Verify & Approve",
    desc: "Authorized users review and confirm before payment.",
  },
  {
    svg: svg111,
    title: "Pay Instantly",
    desc: "Funds are sent securely via bank or mobile wallet.",
  },
  {
    svg: svg112,
    title: "Track & Report",
    desc: "Get live updates, export reports, and generate proof of settlement.",
  },
];

const titleWorkPayment = "How Bill Payments & Settlements Work";
const subtitleWorkPayment =
  "Process all your supplier and utility payments in four simple steps";
const title="Join the growing network of organizations using Ndovu Pay"
    const subtitle= "Experience the future of business payments with Ndovu Pay"
function SupplierSettlment({ setActive }) {
  return (
    <div id="bill-settlement">
      <BulkPaymentHero
        items={itemsHero}
        title={titleHero}
        subtitle={subtitleHero}
        svg101={img5}
      />
      <WorkSmarter
        items={itemsSmarter}
        title={titleSmarter}
        subtitle={subtitleSmarter}
      />
      <WorkPayment
        items={itemsWorkPayment}
        title={titleWorkPayment}
        subtitle={subtitleWorkPayment}
      />
      <JoinNetwork title={title} subtitle={subtitle} setActive={setActive}/>
    </div>
  );
}

export default SupplierSettlment;
